module.exports = __webpack_public_path__ + "static/media/neal.0bb1959d.jpeg";